import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useGetHospitalsQuery } from "../services/hospitalService";
import { Box, Button } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { getHospitalsColumns } from "../data/hospitals";
import HospitalFormModal from "../components/HospitalFormModal";
import { useAuth } from "../auth/AuthContext";

const Hospitals = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [hospital, setHospital] = useState({
    location: {
      type: "Point",
      coordinates: [],
    },
    address: {
      street: "",
      city: "",
      state: "",
      postCode: "",
      country: "",
    },
    operatingHours: {
      monday: { start: "", end: "" },
      tuesday: { start: "", end: "" },
      wednesday: { start: "", end: "" },
      thursday: { start: "", end: "" },
      friday: { start: "", end: "" },
      saturday: { start: "", end: "" },
      sunday: { start: "", end: "" },
    },
  });

  const {
    data: hospitals,
    error,
    isFetching,
    refetch,
  } = useGetHospitalsQuery({ page: 1, pageSize: 10 });
  const handleAddSuccess = () => {
    refetch();
    setIsModalOpen(false);
  };

  if (isFetching) return <div>Loading...</div>;

  if (error) return <div>Error fetching hospitals</div>;

  const handleView = (hospital: any) => {
    navigate(`/hospitals/${hospital._id}`);
  };

  const handleEdit = (hospital: any) => {
    setHospital(hospital);
    setIsModalOpen(true);
  };

  const handleDelete = (hospital: any) => {};

  const columns = getHospitalsColumns(handleView, handleEdit, handleDelete);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
        {user?.role === "superadmin" ? (
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              // Handle add user logic here
              setIsModalOpen(true);
            }}
          >
            Add Hospital
          </Button>
        ) : null}
      </Box>
      <DataGrid
        rows={hospitals?.data || []}
        columns={columns}
        getRowId={(row) =>
          row._id || Math.random().toString(36).substring(2, 9)
        }
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 10,
            },
          },
        }}
        pageSizeOptions={[10]}
        disableRowSelectionOnClick
        sx={{
          "& .MuiDataGrid-cell": {
            padding: "8px 16px",
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: "#f5f5f5",
          },
        }}
      />

      {/* Add/Edit Hospital Modal */}
      <HospitalFormModal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSuccess={handleAddSuccess}
        hospital={hospital}
      />
    </Box>
  );
};

export default Hospitals;
